<template>
  <form
    id="email-communication-form"
    name="emailCommuncationForm"
    class="container mt-3"
    @submit.prevent="sendCommunication"
    v-if="message.to_emails">
    <!-- Emails -->
    <div class="row">
      <div class="col">
        <label for="emails">
          Email:
        </label>
        <b-form-input
          id="emails"
          ref="emails"
          name="emails"
          type="text"
          :value="email"
          disabled>
        </b-form-input>
      </div>
    </div>
    <!-- / Emails -->

    <!-- Subject -->
    <div class="row mt-3">
      <div class="col">
        <label for="subject">Subject:</label>
        <b-form-input
          id="subject"
          ref="subject"
          name="subject"
          type="text"
          placeholder="Enter a subject"
          :value="message.subject"
          disabled>
        </b-form-input>
      </div>
    </div>
    <!-- / Subject -->

    <!-- HTML Body -->
    <div v-if="message.html" class="row mt-3">
      <div class="col">
        <label for="body">Email Content:</label><br>
        <iframe
          style="border: 1px solid #ced4da;"
          width="700"
          height="500"
          :src="message.html">
        </iframe>
      </div>
    </div>
    <!-- / HTML Body -->

    <!-- Body -->
    <div v-if="message.message" class="row mt-3">
      <div class="col">
        <label for="body">Body:</label>
        <b-form-textarea
          id="body"
          ref="body"
          name="body"
          rows="5"
          :value="message.message"
          disabled
          placeholder="Enter a message body"
          no-resize>
        </b-form-textarea>
      </div>
    </div>
    <!-- / Body -->

    <!-- Attachments -->
    <div class="row mt-3">
      <div class="col">
        <label for="attachments">
          Attached Files:
        </label>

        <!-- Attachments Table -->
        <b-table
          striped
          small
          show-empty
          sort-by="name"
          class="file-attachments"
          :items="fileOptions"
          :fields="attachmentFields"
          empty-text="No attached files.">
          <template slot="remove"></template>
          <template
            slot="created"
            slot-scope="{ item }">
            {{ item.created | datetime }}
          </template>
        </b-table>
        <!-- / Attachments Table -->
      </div>
    </div>

    <div v-if="$route.params.type !== 'text'" class="corner-buttons">
      <!-- Save Event Button -->
      <b-button
        class="shadow"
        type="submit"
        variant="success"
        :disabled="isDisabled">
        <font-awesome-icon icon="paper-plane"></font-awesome-icon> Resend
      </b-button>
      <!-- / Save Event Button -->
    </div>
  </form>
</template>

<script>
import _ from 'lodash';
import DataSvc from '../services/data';
import AppMixin from '../services/app-mixin';
import CommunicationMixin from '../services/communication-mixin';
import BrowserStorageMixin from '../services/browser-storage-mixin';
import FileUploadMixin from '../services/file-upload-mixin';
import EventBus from '../services/event-bus';

export default {
  name: 'email-communication',
  mixins: [
    AppMixin,
    CommunicationMixin,
    BrowserStorageMixin,
    FileUploadMixin,
  ],
  computed: {
    isDisabled() {
      return this.submitting;
    },
    email() {
      return (this.message.to_emails || [])[0];
    },
  },
  methods: {
    sendCommunication() {
      const message = {
        email_log_entry_id: this.message.id,
        organization_id: this.loggedInUser.actingOrg.id,
      };

      this.showToast('Resending message...');
      this.submitting = true;

      // eslint-disable-next-line
      return DataSvc.sendCommunication(message)
        .then(() => this.delay(1000))
        .then(() => {
          this.showToast('Message resent!');
          this.messageCopy = _.cloneDeep(this.message);
          this.$router.replace({
            name: 'communications',
          });
        })
        .finally(() => this.delay(1000))
        .finally(() => {
          this.submitting = false;
          this.hideToast();
        });
    },
  },
  created() {
    this.showGlobalLoader('Loading message...');

    const initCommunicationEmail = () => {
      const { communicationID, type } = this.$route.params;

      // begin to form message object
      this.message.id = communicationID;

      // watch for org change and route to events page
      EventBus.$on('acting-org-changed', this.goToEvents);

      // get the rest of message data
      return DataSvc.getCommunicationByID(communicationID, type)
        .then((message) => {
          const attachments = _.map(message.attachments, a => ({
            filename: a.filename,
            created: message.created_at,
            value: _.uniqueId(),
          }));

          const emailContent = message.html_content
            ? `data:text/html,${encodeURIComponent(message.html_content)}`
            : null;

          _.merge(this.message, {
            id: message.id,
            to_emails: [message.to_email],
            subject: message.subject,
            message: message.text_content,
            html: emailContent,
            attachment_uuids: _.map(attachments, 'value'),
          });

          this.fileOptions = attachments;
          this.$forceUpdate();
        }, () => {
          this.$router.push({ name: 'communications' });
        });
    };

    this.initPromise.then(initCommunicationEmail).finally(this.hideGlobalLoader);
  },
  destroyed() {
    EventBus.$off('acting-org-changed', this.goToEvents);
  },
};
</script>

<style lang="scss">
#email-communication-form {
  .remove-file {
    width: 0;
    padding: 0;
  }
}
</style>
